export default "__VITE_ASSET__Cnf8og0c__"